// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"61173758","456":"b99faa49","592":"f0107403","856":"e41ea559"}[chunkId] + ".chunk.js";
};